import { PHONE_NUMBER } from '@/constants/Common'
import { LocalePerformance } from '../en/performance'

const performance: LocalePerformance = {
  myPerformance: '我的表现',
  wins: '获胜',
  losses: '失败',
  avgPoints: '平均分数',
  avgPts: '平均分数',
  avgPartner: '搭档平均级别',
  avgPtr: '搭档平均级别',
  avgOpponent: '对手平均级别',
  win: '胜利',
  loss: '失败',
  reject: '不合格',
  validate: '验证',
  validateMatch: '验证比赛',
  confirmValidateMatch: '您确定要验证这些分数吗？如果是这样，比赛结束并且选手等级将会更新',
  matchSourceLeague: `如果这些分数不正确，请联系赛事负责人或发短信 ${PHONE_NUMBER} 告知正确的分数。`,
  deleteMatchConfirm: '如果您删除此比赛，您将不得不重新输入分数，这会影响您的评分',
  halfLife: '半衰期',
  avgOpp: '平均上升',
  matchesEmpty: '您还没有进行任何比赛！',
  matchesEmptyDes: '找到一些玩家一起玩，开始你的旅程！',
}

export default performance
